import { useQuery } from "@apollo/client";
import { IonButton, IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLoading, IonPage, IonRow, IonTitle, IonToolbar, useIonToast } from "@ionic/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { getTSPayLinkToSaveQuery } from "../../apollo-client/queries";
import { useSelectedSalesPoint } from "../../hooks/selectedSalesPoint";
import "./payOrderTSPay.css";
import { getPrice } from "../../utils";
import { useTenant } from "../../hooks/multiTenancy";
import { informationCircle } from "ionicons/icons";

type ModalProps = {
  guestModal?: boolean;
};

const PayOrderTSPay: React.FC<ModalProps> = ({ guestModal = false }) => {
  const tenant = useTenant();
  const { t } = useTranslation();
  const history = useHistory();
  const [toast] = useIonToast();
  const [selectedSalesPointId] = useSelectedSalesPoint();
  const { idTable, idOrder, sourceType } = useParams<{ idTable?: string; idOrder: string; sourceType: string }>();

  const urlOrigin = window.location.origin;
  let responseUrl = `${urlOrigin}/tspay-response/${idOrder}`;
  if (guestModal) {
    responseUrl = `${urlOrigin}/prepay/tspay-response/${idTable!}/${idOrder}`;
  }

  const tspayLinkResponse = useQuery(getTSPayLinkToSaveQuery, { variables: { idSalesPoint: selectedSalesPointId, idOrder, callbackUrl: responseUrl, sourceTypes: sourceType } });
  const tspayUrl = tspayLinkResponse?.data?.TSPayLinkToSave.tspayLinkToSaveUrl;

  const goPayment = () => {
    if (tspayLinkResponse.data) {
      window.location.href = tspayUrl;
    }
  };

  useEffect(() => {
    if (tspayLinkResponse.error) {
      toast({
        cssClass: "order-payed-toast",
        color: "light",
        message: t("pay_order.tsPayErrorMsg"),
        duration: 2000,
        animated: true,
        position: "middle",
        onDidDismiss: () => {
          history.push(guestModal ? `/select/table/${selectedSalesPointId}/${idTable!}` : "/app/orders");
        },
      });
    }
    if (tspayLinkResponse.data) {
      if (tspayLinkResponse.data.TSPayLinkToSave.confirmationMethod !== "EXPLICIT") {
        window.location.href = tspayUrl;
      }
    }
  }, [tspayLinkResponse]);

  return (
    <IonPage className="pay-order">
      <IonHeader>
        <IonToolbar color="secondary">
          <IonTitle>{t("pay_order.title")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonLoading isOpen={tspayLinkResponse.loading} />
      <IonContent fullscreen>
        {tspayLinkResponse.data && tspayLinkResponse.data.TSPayLinkToSave.confirmationMethod === "EXPLICIT" && (
          <IonCard className="explicit-confirmation-card">
            <IonGrid>
              <IonRow>
                <IonCol size="2"><IonIcon className="icon" icon={informationCircle} color="success" /></IonCol>
                <IonCol size="10">
                  <IonCardHeader>
                    <IonCardTitle className="title">{t("pay_order.explicitConfirmationMsg", { amount: getPrice(0, tenant.settings?.fidelityAccount?.account.currency) })}</IonCardTitle>
                  </IonCardHeader>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCard>
        )}
      </IonContent>
      {tspayLinkResponse.data && tspayLinkResponse.data.TSPayLinkToSave.confirmationMethod === "EXPLICIT" && (
        <IonFooter className="confirm-bar">
          <IonButton onClick={() => goPayment()} expand="block">
            {t("table_payment.pay")}
          </IonButton>
        </IonFooter>
      )}
    </IonPage>
  );
};

export default PayOrderTSPay;
